/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidMutationResponse,
  DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidPathParams,
  DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidQueryParams,
  DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid400,
  DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid401,
  DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid500,
} from "../../types/individualPaymentEditorsController/DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid.ts";

function getDeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidUrl(
  financialPersonId: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidPathParams["financialPersonId"],
  couponId: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidPathParams["couponId"],
) {
  const res = {
    method: "DELETE",
    url: `/api/v1/individualpayment/financial-people/${financialPersonId}/coupons/${couponId}` as const,
  };
  return res;
}

/**
 * @description Desativa o vínculo com justificativa e subtrai o desconto do plano (piso zero). Migrado do legado IndividualPayment/RemoveCoupon. **(Requer Authorization para autenticação)**
 * @summary Remove um cupom aplicado ao plano financeiro (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/coupons/:couponId}
 */
export async function deleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid(
  financialPersonId: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidPathParams["financialPersonId"],
  couponId: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidPathParams["couponId"],
  params?: DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid400
      | DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid401
      | DeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponid500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsCouponidUrl(
      financialPersonId,
      couponId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
